import React from "react";
import ReactApexChart from "react-apexcharts";

const Line = ({
    series = [],
    leftText,
    bottomText,
    maxXaxis,
    dataColors,
    showAvgCheck = false,
    currency = '$'
}) => {

    let columnData = [];
    let lineData = [];
    let avgCheckData = [];
    let dateData = [];

    for (let i = 0; i < series.length; i++) {

        // Revenue - Commented out
        // columnData.push(
        //     Number(series[i]?.revenue || 0)
        // );

        // Item Sold - Now this will be the column data
        columnData.push(
            Number(series[i]?.chk_count || 0)
        );

        // Avg Check
        avgCheckData.push(
            Number(series[i]?.avg_check || 0)
        );

        // Date
        dateData.push(
            series[i]?.row_dt || ''
        );
    }

   
     //SERIES
   

    const seriesvalues = [
        {
            name: "Item Sold",  // Changed from Revenue to Item Sold
            type: "column",
            data: columnData,
        },
        // Commented out Revenue series
        // {
        //     name: "Item Sold",
        //     type: "column",
        //     data: lineData,
        // },
    ];

     //Always show Avg Check when showAvgCheck is true.

    if (showAvgCheck) {
        seriesvalues.push({
            name: "Avg Check",
            type: "line",
            data: avgCheckData,
        });
    }

    
    // COLORS
    const colors = showAvgCheck
        ? [
            '#F26B5B', // Item Sold (was Revenue)
            '#F7B84B', // Avg Check
        ]
        : [
            '#F26B5B', // Item Sold (was Revenue)
        ];

     //FIND MAX VALUES
     
    // Calculate proper max values with better scaling
    const allItemSoldValues = columnData.length
        ? columnData
        : [0];

    const allAvgCheckValues = avgCheckData.length
        ? avgCheckData
        : [0];

    const itemSoldMax = Math.max(...allItemSoldValues, 0);
    const avgCheckMax = Math.max(...allAvgCheckValues, 0);

    // Better max calculation for left axis (Item Sold)
    let leftAxisMax;
    if (itemSoldMax === 0) {
        leftAxisMax = 1;
    } else if (itemSoldMax <= 1) {
        leftAxisMax = 1;
    } else if (itemSoldMax <= 5) {
        leftAxisMax = 5;
    } else if (itemSoldMax <= 10) {
        leftAxisMax = 10;
    } else {
        leftAxisMax = Math.ceil(itemSoldMax * 1.1);
    }

    // Better max calculation for right axis (Avg Check)
    const rightAxisMax = Math.max(
        avgCheckMax,
        0
    );

    let safeRightAxisMax;
    if (rightAxisMax === 0) {
        safeRightAxisMax = 1;
    } else if (rightAxisMax <= 1) {
        safeRightAxisMax = 1;
    } else if (rightAxisMax <= 5) {
        safeRightAxisMax = 5;
    } else if (rightAxisMax <= 10) {
        safeRightAxisMax = 10;
    } else if (rightAxisMax <= 50) {
        safeRightAxisMax = Math.ceil(rightAxisMax / 10) * 10;
    } else {
        safeRightAxisMax = Math.ceil(rightAxisMax * 1.1);
    }

    // Determine tick amount based on max value
    const getTickAmount = (maxVal) => {
        if (maxVal <= 5) return 5;
        if (maxVal <= 10) return 5;
        if (maxVal <= 50) return 10;
        if (maxVal <= 100) return 10;
        if (maxVal <= 500) return 10;
        return 10;
    };

    const leftTickAmount = getTickAmount(leftAxisMax);
    const rightTickAmount = getTickAmount(safeRightAxisMax);

    
     // OPTIONS
    
    const options = {

        chart: {
            toolbar: {
                show: true,
            },
        },

        stroke: {
            width: showAvgCheck
                ? [0, 3]  // Changed: [Item Sold column, Avg Check line]
                : [0],
        },

         // DATA LABELS - ONLY SHOW FOR AVG CHECK
        
        dataLabels: {
            enabled: true,

            // Only show data labels for Avg Check (series index 1)
            enabledOnSeries: showAvgCheck
                ? [1]  // Only Avg Check (now index 1)
                : [],  // No data labels when avg check is not shown

            // Position the label at the top center of each bar
            position: 'top',

            formatter: function (
                value,
                {
                    seriesIndex
                }
            ) {

                // Avg Check - show with 1 decimal
                if (seriesIndex === 1) {  // Changed from 2 to 1
                    return Number(value).toFixed(1);
                }

                return value;
            },

            offsetY: -5,

            style: {
                fontSize: '10px',
                fontWeight: 400,
            },
        },
        
        // X AXIS   

        labels: dateData,

        xaxis: {
            labels: {
                rotate: -45,
                rotateAlways: false,
                hideOverlappingLabels: true,
                showDuplicates: false,
                trim: true,
                minHeight: 30,
                maxHeight: 60,

                style: {
                    fontSize: '9px',
                },
            },

            categories: dateData,

            tickAmount: Math.min(
                Math.max(dateData.length, 1),
                60
            ),

            min: dateData.length > 0 ? undefined : 0,
            max: dateData.length > 0
                ? undefined
                : 1,
        },

        // Y AXIS
     

        yaxis: [
            {
                
                 // Item Sold axis (left side)
                min: 0,

                max: leftAxisMax,

                forceNiceScale: true,

                tickAmount: leftTickAmount,

                title: {
                    text: leftText || "Item Sold",  // Changed from Revenue to Item Sold

                    style: {
                        fontWeight: 600,
                    },
                },

                labels: {
                    formatter: function (value) {
                        // Show as whole numbers
                        return Math.round(value);
                    },
                },
            },

            {

                opposite: true,

                min: 0,

                max: safeRightAxisMax,

                forceNiceScale: true,

                tickAmount: rightTickAmount,

                title: {
                    text: "Avg Check",  // Changed from "Avg Check / Item Sold" to just "Avg Check"

                    style: {
                        fontWeight: 600,
                    },
                },

                labels: {
                    // Show as whole numbers (integers) without decimals
                    formatter: function (value) {
                        // Round to nearest integer
                        return Math.round(value);
                    },
                },
            },
        ],

        colors: colors,

        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            floating: false,
            offsetY: 0,
            offsetX: 0,

            fontSize: '12px',
            fontWeight: 500,

            markers: {
                width: 12,
                height: 12,
                strokeWidth: 0,
                radius: 2,
            },

            itemMargin: {
                horizontal: 10,
                vertical: 5,
            },
        },

        // TOOLTIP - SHOW ALL THREE DATA
        
        tooltip: {
            shared: true,
            intersect: false,

            y: {
                formatter: function (
                    value,
                    {
                        seriesIndex
                    }
                ) {

                    // Avg Check - show with 1 decimal in tooltip
                    if (showAvgCheck && seriesIndex === 1) {  // Changed from 2 to 1
                        return Number(value).toFixed(1);
                    }

                    // Item Sold - show as whole numbers
                    return Math.round(value);
                },
            },
        }, 

        // GRID

        grid: {
            borderColor: '#e0e0e0',

            row: {
                colors: [
                    'transparent',
                    'transparent'
                ],
                opacity: 0,
            },
        },

        // PLOT OPTIONS

        plotOptions: {
            bar: {
                columnWidth: '60%',
                borderRadius: 2,
            },
        },

        noData: {
            text: '',
        },
    };

    return (
        <React.Fragment>
            <ReactApexChart
                options={options}
                series={seriesvalues}
                type="line"
                height={350}
            />
        </React.Fragment>
    );
};

export {
    Line
};